export type QueryKeys = {
  users: {
    supabaseUser: (appName: string) => ["supabase-session-user", string];
  };
};

/**
 * When using Tanstack Query outside of tRPC we need t manage the query keys ourselves.
 * This is acts as a central place for us to define them.
 */
export const queryKeysFactory: QueryKeys = {
  users: {
    supabaseUser: (appName: string) => ["supabase-session-user", appName]
  }
} as const;
